import { useState, useEffect } from 'react';
import "./FormQuestionDeleteModal.css";
import Modal from "../shared/Modal";

type FormQuestionDeleteModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
}

export const FormQuestionDeleteModal = ({isOpen, onClose, onSubmit}: FormQuestionDeleteModalProps) => {

    console.log("[FormQuestionDeleteModal] isOpen: ", isOpen);

    return (
        <Modal
            isOpen={isOpen}
            style={null}
            onClose={onClose}
            canClose={true}
            allowClickout={true}
        >
            <div 
                className="form-question-delete-container"
                data-testid="form-question-delete-modal"
            >
                <div className="modal-title">
                    Delete question?
                </div>
                
                <p>Are you sure you want to delete this question?</p>
                Any responses to this question will be lost

                <div className="modal-buttons">
                    <button 
                        className="button-cancel"
                        onClick={onClose}
                    > 
                        Cancel
                    </button>

                    <button 
                        className="button-save"
                        onClick={onSubmit}
                        data-testid="form-question-delete-modal-submit"
                    > 
                        Delete
                    </button>
                </div>
               
            </div>
      </Modal>
    )
}